import { POST_PORTOFOLIO_START } from '../../types';

export const post_portofolio = (payload) => ({
  type: POST_PORTOFOLIO_START,
  payload,
});
